import { getCurrentLocale } from '@/i18n';
import { USER_GROUP_AEROPLAN, USER_GROUP_AFFILIATE, USER_GROUP_B2B, USER_GROUP_B2B_ADMIN, USER_GROUP_B2B_AGENT, USER_GROUP_EMPLOYEE, USER_GROUP_FANDF } from '@/constants';
import { MpvDataLayer } from '@/modules/analytics/MpvDataLayer';
import { useUserInfo } from '@/modules/user/useUserInfo';

function getSpaType(group: Array<string>): string {
  const audience = getAudience(group) === 'B2C' ? 'B2C' : 'B2B';
  return `Group Quoting Tool (${audience})`;
}

function getAudience(groups: Array<string>): string {
  if (groups.includes(USER_GROUP_FANDF)) {
    return 'Friends&Family';
  } else if (groups.includes(USER_GROUP_AFFILIATE)) {
    return 'Affiliate';
  } else if (groups.includes(USER_GROUP_AEROPLAN)) {
    return 'Aeroplan B2C Logged In';
  } else if (groups.includes(USER_GROUP_B2B) || groups.includes(USER_GROUP_B2B_ADMIN) || groups.includes(USER_GROUP_B2B_AGENT)) {
    return 'B2B';
  } else if (groups.includes(USER_GROUP_EMPLOYEE)) {
    return 'Employee';
  }
  return 'B2C';
}

// SPA GTM Events as hidden inputs
// - spa_data_mpv
// - spa_data_language
// - spa_data_audience
// - spa_data_signInStatus
// - spa_data_pageType
// - spa_data_userID
function getUserId(): string {
  const spaUserId = document.getElementById('spa_data_userID') as HTMLInputElement;
  if (spaUserId !== null && spaUserId.value.trim() !== '') {
    return spaUserId.value;
  } else {
    return '';
  }
}

export const publishMpvAnalytic = async (page: string) => {
  useUserInfo()
    .getUserInfo()
    .then((currentUser) => {
      const groups = currentUser?.groups ?? [];
      const isGuest = currentUser?.isGuestUser;
      const dataLayer = {} as MpvDataLayer;
      dataLayer.event = 'mpv';
      dataLayer.language = getCurrentLocale().toUpperCase();
      dataLayer.pageType = page;
      dataLayer.spaType = getSpaType(groups);
      dataLayer.audience = getAudience(groups);
      dataLayer.signInStatus = (isGuest ? 'Not ' : '') + 'Signed In';
      dataLayer.userID = getUserId();
      window.dataLayer?.push(dataLayer);
    });
};
